import { RoleType } from "app/store/reducer/requestflow";
import { get } from "app/utils/axios/kheti";

export interface UserRoleResponse {
  id: number;
  name: string;
 role_type: RoleType[];
}

const fetchUserRole = async (): Promise<UserRoleResponse | null> => {
  try {
  
    const response = await get<UserRoleResponse>(
      `/approvals/v1/user-role`,
    );
    return response;
    
  } catch (e) {
    console.log("Error fetching user role:", e);
    return null;
  }
};

export default fetchUserRole;